/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import { Box, Modal, Typography } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Loading from "../../../../../home/components/Loading";
import { AppAPIService } from "../../../../../../services/AppAPIService";
import Swal from "sweetalert2";
import InputForm from "../../../../../../components/InputForm";
import { ReactComponent as IconCircleLeft } from "../../../../../../assets/icons/akar-icons_circle_dark.svg";
import { ReactComponent as iconPlus } from "../../../../../../assets/icons/icon-plus-green.svg";
import { ReactComponent as IconCircleRight } from "../../../../../../assets/icons/icon_circle-chevron-right-fill.svg";
import { globalColors } from "../../../../../../../_metronic/_assets/sass/custom/globalColors";
import styles from "./styles.module.scss";
import moment from "moment";
import InputDateForm from "../../../../../../components/InputDateForm";

export const DocumentCategoryModal = (props) => {
  const app = new AppAPIService();
  const api = AppAPIService.getInstance();
  const submitting = useRef(false);

  const [documentCategoryList, setDocumentCategoryList] = useState([]);
  const [automaticMessagesList, setAutomaticMessagesList] = useState([]);
  const [automaticMessageGroupedById, setAutomaticMessageGroupedById] =
    useState({});
  const [documentList, setDocumentList] = useState([]);

  /* Category */
  const [category, setCategory] = useState([]);
  const [categoryRole, setCategoryRole] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const handleInputCategory = (e) => {
    if (e.length < 1) {
      setCategory([]);
      setCategoryError("");
      setCategoryRole("ok");
      return;
    } else {
      setCategory(e);
      setCategoryError("");
      setCategoryRole("ok");
    }
  };
  /* end Category*/

  /* limitDate */
  const [limitDate, setLimitDate] = useState("");
  const [limitDateRole, setLimitDateRole] = useState("");
  const [limitDateError, setLimitDateError] = useState("");
  const handleInputLimitDate = (e) => {
    if (!e) {
      setLimitDate();
      setLimitDateError("");
      setLimitDateRole("ok");
    } else {
      setLimitDate(e);
      setLimitDateError("");
      setLimitDateRole("ok");
    }
  };
  /* end limitDate*/

  /* Message */
  const [message, setMessage] = useState("");
  const [messageRole, setMessageRole] = useState("");
  const [messageError, setMessageError] = useState("");
  const handleInputMessage = (e) => {
    if (!e) {
      setMessage();
      setMessageError("");
      setMessageRole("ok");
      return;
    } else {
      setMessage(e);
      setMessageError("");
      setMessageRole("ok");
    }
  };
  /* end Message*/

  const [loading, setLoading] = useState(true);

  const getDocumentList = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        url: `/document/list-paginated`,
        params: {
          lawsuitId: props.lawsuitId,
        },
        method: "GET",
      });

      const mappedDocumentList = response.data.map((item) => {
        return item.documentCategory.id;
      });
      setDocumentList(mappedDocumentList);
      try {
        const response = await api.makeHttpRequest({
          method: "GET",
          url: "/document-category/list-paginated",
          params: {
            page: 1,
            perPage: 1000,
            search: "",
          },
        });
        const specificDocuments = response.data
          .filter((item) => item?.type?.name === "específico")
          .filter((item) => !mappedDocumentList.includes(item.id))
          .map((item) => {
            return { value: item.id, label: item.name };
          });
        setDocumentCategoryList(specificDocuments);
      } catch (e) {
        Swal.fire("Erro!", "Erro ao buscar categorias de documentos.", "error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [api, props.lawsuitId]);

  const getAutomaticMessagesList = useCallback(async () => {
    try {
      setLoading(true);
      try {
        const response = await api.makeHttpRequest({
          url: `/automatic-message/list-paginated`,
          method: "GET",
          params: {
            page: 1,
            limit: 1000,
            perPage: 1000,
            search: "",
          },
        });

        const groupedById = response.data.reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {});
        setAutomaticMessageGroupedById(groupedById);

        const automaticMessages = response.data.map((item) => {
          return { value: item.id, label: item.title };
        });
        setAutomaticMessagesList([
          { value: "custom", label: "Mensagem customizada" },
          ...automaticMessages,
        ]);
      } catch (e) {
        Swal.fire("Erro!", "Erro ao buscar mensagens automáticas.", "error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    getDocumentList();
  }, [getDocumentList, props.reload]);

  useEffect(() => {
    getAutomaticMessagesList();
  }, [getAutomaticMessagesList, props.reload]);

  const [messageText, setMessageText] = useState("");
  const [messageTexRole, setMessageTextRole] = useState("");
  const [messageTextError, setMessageTextError] = useState("");
  const handleInputMessageText = (e) => {
    if (!e) {
      setMessageText();
      setMessageTextError("");
      setMessageTextRole("ok");
      return;
    } else {
      setMessageText(e);
      setMessageTextError("");
      setMessageTextRole("ok");
    }
  };

  useEffect(() => {
    if (message && message.value === "custom") {
      setMessageText("");
    } else if (message) {
      setMessageText(automaticMessageGroupedById[message.value].message);
    }
    setMessageTextError("");
    setMessageTextRole("ok");
  }, [message, automaticMessageGroupedById]);

  const handleCloseModal = useCallback(() => {
    if (submitting.current) return;
    setCategory([]);
    setMessage("");
    setMessageText("");
    setLimitDate(null);
    props.handleOpen(false);
  }, [props]);

  const checkSubmit = useCallback(() => {
    if (!category || category?.length === 0) {
      setCategoryError("Selecione uma categoria");
      setCategoryRole("error");
    } else if (!limitDate || limitDate === "") {
      setLimitDateError("Selecione uma data limite");
      setLimitDateRole("error");
    } else if (!messageText || messageText === "") {
      setMessageTextError("Digite uma mensagem");
      setMessageTextRole("error");
    } else {
      return true;
    }
    return false;
  }, [category, limitDate, messageText]);

  /* submit */
  const submit = useCallback(
    async (e) => {
      e.preventDefault();
      if (submitting.current) return;

      const check = checkSubmit();

      if (!check) {
        setLoading(false);
        return;
      }

      submitting.current = true;
      try {
        setLoading(true);
        await api.makeHttpRequest({
          url: `/document/create/separate`,
          method: "POST",
          data: {
            documentCategoryId: category,
            lawsuitId: Number(props.lawsuitId),
            limitDate: moment(limitDate)
              .set("h", 3)
              .utc()
              .format("YYYY-MM-DD HH:mm:ss"),
            message: messageText,
          },
        });
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: "Solicitação de documento cadastrada com sucesso.",
        });
        submitting.current = false;
        handleCloseModal();
        props.setReload(!props.reload);
      } catch (error) {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Erro ao adicionar documento avulso.",
        });
      } finally {
        submitting.current = false;
        setLoading(false);
      }
    },
    [api, category, messageText, limitDate, props, checkSubmit, handleCloseModal]
  );
  /* end submit */

  return (
    <>
      <Loading isLoading={loading} />
      <Modal
        open={props.open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEnforceFocus // não fecha quando perde o foco
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <Box
            className={styles.modalContent}
            sx={{
              width: "min(900px, calc(100vw - 32px))",
              maxHeight: "calc(100vh - 32px)",
              overflowY: "auto",
              overflowX: "hidden",
              backgroundColor: "var(--xv-card, #fffdfc)",
              borderRadius: "8px",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography
              className={styles.modalTitle}
              id="modal-modal-title"
              style={{
                textAlign: "center",
                color: globalColors.primaryColor1,
                marginTop: "20px",
              }}
              variant="h1"
              fontSize="24px"
              fontWeight="bold"
            >
              Novo Documento
            </Typography>
            <Typography
              className={styles.modalDescription}
              id="modal-modal-description"
              style={{
                color: globalColors.textColor2,
                fontSize: "16px",
                textAlign: "center",
                margin: "24px 0 40px 0",
              }}
            >
              <span>
                Você pode adicionar um novo documento à lista de solicitações
              </span>
            </Typography>

            <Box
              className={styles.formRow}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                width: "100%",
                border: "none",
                boxShadow: "none",
                marginTop: "24px",
              }}
            >
              <div className={styles.addDocumentButton}>
                <InputForm
                  isMulti
                  isSelectV2
                  placeholder="Selecione o documento"
                  label="Documento *"
                  role={categoryRole}
                  value={category}
                  options={documentCategoryList}
                  onChange={handleInputCategory}
                  error={categoryError}
                  isSearchable={true}
                />
              </div>
              <div className={styles.addDocumentButton}>
                <InputForm
                  isSelectV2
                  isSearchable
                  searchPlaceholder="Buscar modelo..."
                  placeholder="Selecione um modelo"
                  label="Modelo da mensagem *"
                  role={messageRole}
                  value={message}
                  options={automaticMessagesList}
                  onChange={handleInputMessage}
                  error={messageError}
                />
              </div>
            </Box>

            <Box
              className={styles.formRow}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                width: "100%",
                margin: "34px 0 48px 0",
                border: "none",
                boxShadow: "none",
              }}
            >
              <div className={styles.addDateButton}>
                <InputDateForm
                  name="dateField"
                  label="Data Limite"
                  height={"48px"}
                  style={{ width: "100%" }}
                  placeholder="Selecione uma data"
                  withPortal
                  onChange={handleInputLimitDate}
                  value={limitDate}
                  role={limitDateRole}
                  error={limitDateError}
                />
                <p style={{
                  color: 'red',
                  fontWeight: '500',
                  fontSize: '12px',
                }}>{limitDateError}</p>
              </div>
              <div className={styles.addDateButton}>
                <InputForm
                  type="textarea"
                  placeholder="Texto que será enviado"
                  label="Texto da mensagem *"
                  role={messageTexRole}
                  value={messageText}
                  onChange={handleInputMessageText}
                  error={messageTextError}
                  isDisabled={!message || message.value !== "custom"}
                />
              </div>
            </Box>

            <Box
              className={styles.modalActions}
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                marginTop: "24px",
                boxShadow: "none",
              }}
            >
              <button
                className={styles.cancelAction}
                type="button"
                disabled={loading}
                onClick={() => {
                  if (submitting.current) return;
                  setCategory([]);
                  setMessage(null);
                  setMessageText(null);
                  setLimitDate(null);
                  props.handleOpen(false);
                }}
              >
                <IconCircleLeft />
                <span>Cancelar</span>
              </button>
              <button
                className={styles.primaryAction}
                type="submit"
                onClick={submit}
                disabled={loading}
                title={"anexar"}
              >
                <span>{loading ? "Carregando..." : "Salvar"}</span>
                <IconCircleRight />
              </button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DocumentCategoryModal;
